import CommonVideo from '../commons/Video'

export default class DocumentVideo extends CommonVideo {}
